/** Formatos da Base de Conhecimento: data curta e commit curto, sempre em monospace na tela. */
import type { KbDocumentStatus } from '@/api/kb'

export function formatarData(iso: string): string {
  return new Date(iso).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' })
}

/** Oito caracteres: o bastante para achar o commit no GitLab e caber na coluna. */
export function shaCurto(sha: string): string {
  return sha.slice(0, 8)
}

/** O selo de estado do documento: a lista da pasta e o resultado da busca usam o mesmo. */
export const STATUS_DO_DOCUMENTO: Record<KbDocumentStatus, { label: string; color: string }> = {
  pending: { label: 'Pendente', color: 'gray' },
  indexing: { label: 'Indexando', color: 'blue' },
  indexed: { label: 'Indexado', color: 'green' },
  failed: { label: 'Falhou', color: 'red' },
  disabled: { label: 'Inativo', color: 'yellow' },
}

/**
 * O motivo de um documento `failed`, em português. O worker grava código para o que
 * ele sabe explicar (consoleai#25747); o resto é a mensagem da exceção, mostrada como veio.
 */
const MOTIVO_DA_FALHA: Record<string, string> = {
  pdf_sem_texto:
    'PDF sem texto (escaneado): a Base de Conhecimento ainda não lê PDF escaneado. Envie o PDF com texto pesquisável ou as páginas como imagem.',
  imagem_sem_texto:
    'Imagem sem conteúdo legível: a leitura da imagem não encontrou texto nem descrição. Envie uma imagem mais nítida ou o documento em PDF com texto.',
}

export function motivoDaFalha(erro: string): string {
  return MOTIVO_DA_FALHA[erro] ?? erro
}
